import type { AppManifest, AuthState } from '@sparky/framework'
import type { AppFilterFn } from '../../types'

export const appStaticFilter: AppFilterFn = (app: AppManifest | undefined): app is AppManifest => Boolean(
  app?.enabled && !app.extension_to &&
  !app.no_app_tile_ui && !app.no_more_app_tile &&
  (app.is_panw || app.is_third_party) &&
  (app.is_panw ? app.iam_controlled || app.flags?.iam_controlled : app.is_third_party)
)

export const getAppsFilterFn = (user: AuthState['user']): AppFilterFn => {
  const hasCspId = () => {
    if (!user?.supportAccountIds) {
      return (cspId: number | string) => false
    }
    const idSet = new Set(user.supportAccountIds.map((acc: { accountid: number }) => acc.accountid) || [])
    return (cspId: number | string) => idSet.has(+cspId)
  }
  return (app: AppManifest | undefined): boolean => appStaticFilter(app) &&
    (!app?.restricted_accounts || app.restricted_accounts.some(hasCspId))
}
